import { InjectionToken } from '@angular/core';
import { MouldLogEntry } from 'src/app/models/domain';
import { PagedCollection } from 'src/app/state';

export const MOULD_LOG_PAGINATOR = new InjectionToken('MOULD_LOG_PAGINATOR', {
  factory: () => new PagedCollection<MouldLogEntry>(),
  providedIn: 'root',
});
